// import React, { useState, useMemo } from 'react';
// import { Card } from '@components/card/card';

// interface PurchaseOrderTableProps {
//   data: any[];
//   selectedId: string | null;
//   onSelect: (id: string, code: string) => void;
//   isLoading: boolean;
//   language: string;
// }

// export const SupplirReturnTable: React.FC<PurchaseOrderTableProps> = ({
//   data,
//   selectedId,
//   onSelect,
//   isLoading,
//   language
// }) => {
//   const isArabic = language === 'ar';
//   const [searchTerm, setSearchTerm] = useState('');

//   // Filter data based on search
//   const filteredData = useMemo(() => {
//     if (!searchTerm.trim()) return data;

//     const term = searchTerm.toLowerCase();

//     return data.filter(item => {
//       // Search in all relevant fields
//       return (
//         item.code?.toLowerCase().includes(term) ||
//         (isArabic ? item.peopleName2 || item.peopleName : item.peopleName || item.peopleName2)
//           ?.toLowerCase()
//           .includes(term) ||
//         item.organizationName?.toLowerCase().includes(term) ||
//         item.organizationName2?.toLowerCase().includes(term) ||
//         item.netAmount?.toString().includes(term) ||
//         item.transactionDate?.toLowerCase().includes(term) ||
//         item.grossAmount?.toString().includes(term)
//       );
//     });
//   }, [data, searchTerm, isArabic]);

//   // Calculate totals
//   const totalAmount = useMemo(() => {
//     return filteredData.reduce((sum, item) => sum + (item.netAmount || 0), 0);
//   }, [filteredData]);

//   const selectedAmount = useMemo(() => {
//     const selectedItem = filteredData.find(item => item.id === selectedId);
//     return selectedItem ? selectedItem.netAmount || 0 : 0;
//   }, [filteredData, selectedId]);

//   if (isLoading) {
//     return (
//       <div className='text-center py-5'>
//         <div className='spinner-border text-primary' role='status'>
//           <span className='visually-hidden'>جاري التحميل...</span>
//         </div>
//         <p className='text-muted mt-2'>جاري تحميل أوامر الشراء...</p>
//       </div>
//     );
//   }

//   return (
//     <Card className='mb-4'>
//       <div className='card-header d-flex justify-content-between align-items-center'>
//         <h6 className='mb-0'>
//           <i className='fas fa-shopping-cart me-2'></i>
//           قائمة مردودات الشـراء
//         </h6>
//       </div>

//       {/* Search Bar - Simplified */}
//       <div className='card-body border-bottom'>
//         <div className='row g-2 align-items-center'>
//           <div className='col-md-8'>
//             <div className='input-group'>
//               <span className='input-group-text '>
//                 <i className='fas fa-search'></i>
//               </span>
//               <input
//                 type='text'
//                 className='form-control form-control-sm'
//                 placeholder='ابحث في المردودات (رقم الأمر، المورد، المبلغ، التاريخ...)'
//                 value={searchTerm}
//                 onChange={e => setSearchTerm(e.target.value)}
//               />
//               {searchTerm && (
//                 <button
//                   className='btn btn-outline-secondary'
//                   type='button'
//                   onClick={() => setSearchTerm('')}
//                   title='مسح البحث'
//                 >
//                   <i className='fas fa-times'></i>
//                 </button>
//               )}
//             </div>
//           </div>

//           <div className='col-md-4 text-end'>
//             <small className='text-muted'>
//               {filteredData.length} من {data.length} مردود
//             </small>
//             {searchTerm && (
//               <div className='mt-1'>
//                 <small className='text-primary'>
//                   <i className='fas fa-filter me-1'></i>
//                   بحث عن: "<strong>{searchTerm}</strong>"
//                 </small>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Table with Fixed Height and Scroll */}
//       <div className='card-body p-0'>
//         <div className='table-responsive' style={{ maxHeight: '300px', overflowY: 'auto' }}>
//           <table className='table table-hover mb-0'>
//             <thead className=' fw-bold' style={{ position: 'sticky', top: 0, zIndex: 1, backdropFilter: 'blur(20px)' }}>
//               <tr>
//                 <th className='text-center small' style={{ width: '50px' }}>
//                   #
//                 </th>
//                 <th className='text-center small' style={{ width: '15%' }}>
//                   الرقم
//                 </th>
//                 <th className='text-center small' style={{ width: '15%' }}>
//                   التاريخ
//                 </th>
//                 <th className='text-center small' style={{ width: '25%' }}>
//                   المورد
//                 </th>
//                 <th className='text-center small' style={{ width: '20%' }}>
//                   المبلغ الإجمالي
//                 </th>
//                 <th className='text-center small' style={{ width: '25%' }}>
//                   الوحدة التشغيلية
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredData.length > 0 ? (
//                 filteredData.map((item, index) => {
//                   const isSelected = selectedId === item.id;

//                   return (
//                     <tr
//                       key={item.id}
//                       className={isSelected ? 'table-primary' : ''}
//                       style={{ cursor: 'pointer' }}
//                       onClick={() => onSelect(item.id, item.code)}
//                     >
//                       <td className='text-center align-middle'>
//                         <div className='form-check'>
//                           <input
//                             type='radio'
//                             className='form-check-input'
//                             name='purchaseOrderSelection'
//                             checked={isSelected}
//                             onChange={() => onSelect(item.id, item.code)}
//                           />
//                         </div>
//                       </td>

//                       <td className='text-center align-middle fw-bold'>{item.code}</td>

//                       <td className='text-center align-middle'>
//                         {item.transactionDate ? item.transactionDate?.split('T')[0] : '-'}
//                       </td>

//                       <td className='text-center align-middle'>
//                         {isArabic ? item.peopleName2 || item.peopleName : item.peopleName || item.peopleName2}
//                       </td>

//                       <td className='text-center align-middle'>
//                         <span className='fw-bold text-primary'>{item.netAmount || 0}</span>
//                       </td>

//                       <td className='text-center align-middle'>
//                         {isArabic
//                           ? item.organizationName2 || item.organizationName
//                           : item.organizationName || item.organizationName2}
//                         {searchTerm &&
//                           (item.organizationName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                             item.organizationName2?.toLowerCase().includes(searchTerm.toLowerCase())) && (
//                             <span className='badge bg-info ms-1' title='مطابق للبحث'>
//                               <i className='fas fa-check-circle me-1'></i>
//                             </span>
//                           )}
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan={6} className='text-center py-4'>
//                     <div className='text-muted'>
//                       <i className='fas fa-search fa-2x mb-3'></i>
//                       <h6 className='mb-2'>لا توجد نتائج للبحث</h6>
//                       <p className='mb-0'>"{searchTerm}" - لم يتم العثور على مردودات تطابق البحث</p>
//                       <button className='btn btn-sm btn-outline-secondary mt-2' onClick={() => setSearchTerm('')}>
//                         <i className='fas fa-times me-1'></i>
//                         مسح البحث وعرض الكل
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div className='card-footer d-flex justify-content-between align-items-center'>
//         <div className='text-muted small'>
//           عرض {filteredData.length} من {data.length} مردود
//         </div>
//       </div>
//     </Card>
//   );
// };


// tables/SupplirReturnTable.tsx
import React, { useState, useMemo } from 'react';
import { Card } from '@components/card/card';
import { useTranslation } from 'react-i18next';

interface PurchaseOrderTableProps {
  data: any[];
  selectedId: string | null;
  onSelect: (id: string, code: string) => void;
  isLoading: boolean;
  language: string;
}

export const SupplirReturnTable: React.FC<PurchaseOrderTableProps> = ({
  data,
  selectedId,
  onSelect,
  isLoading,
  language
}) => {
  const { t } = useTranslation();
  const isArabic = language === 'ar';
  const [searchTerm, setSearchTerm] = useState('');

  // Filter data based on search
  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) return data;

    const term = searchTerm.toLowerCase();

    return data.filter(item => {
      const supplierName = (
        isArabic ? item.peopleName2 || item.peopleName : item.peopleName || item.peopleName2
      )
        ?.toString()
        .toLowerCase();

      return (
        item.code?.toLowerCase().includes(term) ||
        supplierName?.includes(term) ||
        item.organizationName?.toLowerCase().includes(term) ||
        item.organizationName2?.toLowerCase().includes(term) ||
        item.netAmount?.toString().includes(term) ||
        item.transactionDate?.toLowerCase().includes(term) ||
        item.grossAmount?.toString().includes(term)
      );
    });
  }, [data, searchTerm, isArabic]);

  // Calculate totals (جاهزة لو حبيت تستخدمها لاحقاً)
  const totalAmount = useMemo(
    () => filteredData.reduce((sum, item) => sum + (item.netAmount || 0), 0),
    [filteredData]
  );

  const selectedAmount = useMemo(() => {
    const selectedItem = filteredData.find(item => item.id === selectedId);
    return selectedItem ? selectedItem.netAmount || 0 : 0;
  }, [filteredData, selectedId]);

  if (isLoading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>{t('Loading')}</span>
        </div>
        <p className='text-muted mt-2'>{t('LoadingSupplierReturns')}</p>
      </div>
    );
  }

  return (
    <Card className='mb-4'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h6 className='mb-0'>
          <i className='fas fa-shopping-cart me-2'></i>
          {t('SupplierReturnsListTitle')}
        </h6>
      </div>

      {/* Search Bar */}
      <div className='card-body border-bottom'>
        <div className='row g-2 align-items-center'>
          <div className='col-md-8'>
            <div className='input-group'>
              <span className='input-group-text'>
                <i className='fas fa-search'></i>
              </span>
              <input
                type='text'
                className='form-control form-control-sm'
                placeholder={t('SupplierReturnsSearchPlaceholder')}
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  onClick={() => setSearchTerm('')}
                  title={t('ClearSearch')}
                >
                  <i className='fas fa-times'></i>
                </button>
              )}
            </div>
          </div>

          <div className='col-md-4 text-end'>
            <small className='text-muted'>
              {t('SupplierReturnsFilteredCount', {
                filtered: filteredData.length,
                total: data.length
              })}
            </small>
            {searchTerm && (
              <div className='mt-1'>
                <small className='text-primary'>
                  <i className='fas fa-filter me-1'></i>
                  {t('SearchTermLabel')}{' '}
                  "<strong>{searchTerm}</strong>"
                </small>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Table with Fixed Height and Scroll */}
      <div className='card-body p-0'>
        <div className='table-responsive' style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <table className='table table-hover mb-0'>
            <thead
              className='fw-bold'
              style={{ position: 'sticky', top: 0, zIndex: 1, backdropFilter: 'blur(20px)' }}
            >
              <tr>
                <th className='text-center small' style={{ width: '50px' }}>
                  #
                </th>
                <th className='text-center small' style={{ width: '15%' }}>
                  {t('Number')}
                </th>
                <th className='text-center small' style={{ width: '15%' }}>
                  {t('Date')}
                </th>
                <th className='text-center small' style={{ width: '25%' }}>
                  {t('Supplier')}
                </th>
                <th className='text-center small' style={{ width: '20%' }}>
                  {t('TotalAmount')}
                </th>
                <th className='text-center small' style={{ width: '25%' }}>
                  {t('OperatingUnit')}
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map(item => {
                  const isSelected = selectedId === item.id;

                  return (
                    <tr
                      key={item.id}
                      className={isSelected ? 'table-primary' : ''}
                      style={{ cursor: 'pointer' }}
                      onClick={() => onSelect(item.id, item.code)}
                    >
                      <td className='text-center align-middle'>
                        <div className='form-check'>
                          <input
                            type='radio'
                            className='form-check-input'
                            name='purchaseOrderSelection'
                            checked={isSelected}
                            onChange={() => onSelect(item.id, item.code)}
                          />
                        </div>
                      </td>

                      <td className='text-center align-middle fw-bold'>{item.code}</td>

                      <td className='text-center align-middle'>
                        {item.transactionDate ? item.transactionDate?.split('T')[0] : '-'}
                      </td>

                      <td className='text-center align-middle'>
                        {isArabic ? item.peopleName2 || item.peopleName : item.peopleName || item.peopleName2}
                      </td>

                      <td className='text-center align-middle'>
                        <span className='fw-bold text-primary'>{item.netAmount || 0}</span>
                      </td>

                      <td className='text-center align-middle'>
                        {isArabic
                          ? item.organizationName2 || item.organizationName
                          : item.organizationName || item.organizationName2}
                        {searchTerm &&
                          (item.organizationName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            item.organizationName2?.toLowerCase().includes(searchTerm.toLowerCase())) && (
                            <span className='badge bg-info ms-1' title={t('MatchesSearch')}>
                              <i className='fas fa-check-circle me-1'></i>
                            </span>
                          )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6} className='text-center py-4'>
                    <div className='text-muted'>
                      <i className='fas fa-search fa-2x mb-3'></i>
                      <h6 className='mb-2'>{t('NoSearchResultsTitle')}</h6>
                      <p className='mb-0'>
                        {t('NoSupplierReturnsMatchSearch', { term: searchTerm || '' })}
                      </p>
                      <button
                        className='btn btn-sm btn-outline-secondary mt-2'
                        onClick={() => setSearchTerm('')}
                      >
                        <i className='fas fa-times me-1'></i>
                        {t('ClearSearchAndShowAll')}
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className='card-footer d-flex justify-content-between align-items-center'>
        <div className='text-muted small'>
          {t('SupplierReturnsFooterSummary', {
            filtered: filteredData.length,
            total: data.length
          })}
        </div>
      </div>
    </Card>
  );
};
